<script setup lang="ts">
  definePageMeta({
    layout: 'blank'
  })

  const { params } = useRoute()

  const companyId = parseInt(params.companyId as string, 10)
  const { fetchCustomer } = useStoreCustomer()
  const { fetchCompany } = useStoreCompany()
  const { fetchStore, fetchLocales } = useStoreStore()
  const { authenticateFromStore /*, logout */ } = useStoreAuth()

  const retrieveParamsFromIframe = () => {
    // ex: http://site.com/play/loyoly/xx/program/shopify/embedded?offset=45&hash=rewards-111&langcode=en&currencycode=USD&currencyrate=1.0#customer_id=6399397953616
    const url = document.URL
    // ex: ['http://site.com//play/loyoly/xx/program/shopify/embedded?offset=45&hash=rewards-111', 'customer_id=6399397953616']
    const blocks = url.split('#')
    let customerId = ''
    if (blocks.length > 1) customerId = blocks[1].replace('customer_id=', '')
    const { searchParams } = new URL(document.URL)
    const offset = searchParams.get('offset')
    const vh = searchParams.get('vh')
    const anchorHash = searchParams.get('anchor')
    const langCode = searchParams.get('langcode')
    const currencyCode = searchParams.get('currencycode')
    const currencyRate = searchParams.get('currencyrate')
    const langSuffix = searchParams.get('langSuffix')
    const origin = searchParams.get('origin')
    if (searchParams.has('customer_id')) {
      customerId = searchParams.get('customer_id') || ''
    }

    return {
      customerId,
      offset,
      anchorHash,
      vh,
      langCode,
      currencyCode,
      currencyRate,
      langSuffix,
      origin
    }
  }

  useStoreApp().companyId = companyId
  fetchStore(companyId)

  const { customerId, offset, anchorHash, vh, langCode, currencyCode, currencyRate, langSuffix, origin } =
    retrieveParamsFromIframe()
  useStoreStore().viewportHeight = parseInt(vh || '0', 10)
  useStoreStore().offset = parseInt(offset || '0', 10)
  useStoreStore().langCode = langCode
  useStoreStore().langSuffix = langSuffix
  useStoreStore().origin = origin
  useStoreStore().currencyCodeExtension = currencyCode || null
  useStoreStore().currencyRate = !isNaN(parseFloat(currencyRate ?? '')) ? parseFloat(currencyRate ?? '') : 1.0
  const custId = customerId || ''
  useStoreApp().customerId = custId
  await authenticateFromStore(companyId, custId)
  await fetchLocales()
  fetchCustomer()
  fetchCompany()
  useRouter().push({ path: getUrlPrefix(params), query: { offset, anchorHash }, hash: `#${anchorHash}` })
</script>
